import { Injectable } from '@angular/core';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { RoleTypePermissionService } from '@carm/_core/role-type-permissions/services';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { MetadataService } from '@carm/_core/metadata/services';
import { AuthActions } from '@carm/_auth/spartacus/core/auth';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class AppEffects {

  constructor(private actions$: Actions,
    private userService: UserService,
    private metadataService: MetadataService,
    private permissionService: RoleTypePermissionService,
    private router: CarmRouter,
    private dialog: MatDialog) {}

  refreshUserTokenFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.REVOKE_USER_TOKEN),
      switchMap(() => {
        this.userService.logOut();
        this.metadataService.resetMetadata();
        this.permissionService.clearPermissions();
        this.dialog.closeAll();
        return this.router.carmNavigate([RoutesConst.PublicHome]);
      }),
    );
  }, { dispatch: false });

}
